import { useEffect, useState } from 'react';
import { Grid, Typography, Box, InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TextInput, DateInput } from 'qubCommon/Inputs';
import { useMe } from 'hooks/useMe';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import ReCAPTCHAPolicy from 'ui-component/recaptchaPolicy';
import { obscureText } from 'utils/obscureText';
import { currencyNoSymbolTransform } from 'utils/numberToCurrencyLocale';

const PaymentSubmittionForm = ({ readOnly, data }) => {
    const { t } = useTranslation();
    const { whoami } = useMe();
    const { reset } = useFormContext();

    const calculatedSum = data?.Total ?? 0;

    useEffect(() => {
        const signedInUserfullName = whoami ? `${whoami?.firstName} ${whoami?.lastName}` : undefined;
        const signedInUserEmail = whoami?.email;

        // If data object is not null, then use the data object to populate the form
        const fullName = data?.FullName ?? signedInUserfullName;
        const email = data?.Email ?? signedInUserEmail;

        if (data) {
            reset({
                fullName: whoami ? fullName : obscureText(fullName),
                email: whoami ? email : obscureText(email),
                paidAmount: currencyNoSymbolTransform(data?.Total ?? 0),
                paidAt: data?.RelatedTransactionDate ?? null,
                comments: data?.Comments
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return (
        <Box sx={{ boxShadow: 2, p: 2, borderRadius: 2 }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h4" fontSize="16px">
                        {t('PaidByDetails')}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextInput
                        disabled={readOnly}
                        label={t('FullName')}
                        id="fullName"
                        name="fullName"
                        placeholder={t('FullName')}
                        size="medium"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextInput disabled={readOnly} label={t('Email')} id="email" name="email" placeholder={t('Email')} size="medium" />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextInput
                        InputProps={{
                            endAdornment: <InputAdornment position="end">$</InputAdornment>
                        }}
                        disabled
                        label={t('PaidAmount')}
                        id="paidAmount"
                        name="paidAmount"
                        placeholder={t('PaidAmount')}
                        size="medium"
                        value={currencyNoSymbolTransform(calculatedSum)}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <DateInput
                        disabled={readOnly}
                        defaultValue={null}
                        label={t('PaidAt')}
                        id="paidAt"
                        name="paidAt"
                        placeholder={t('PaidAt')}
                        size="medium"
                    />
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextInput
                        disabled={readOnly}
                        label={t('Comments')}
                        id="comments"
                        name="comments"
                        placeholder={t('Comments')}
                        size="medium"
                        multiline
                        rows={3}
                    />
                </Grid>
                <Grid item xs={12} md={12}>
                    <ReCAPTCHAPolicy />
                </Grid>
            </Grid>
        </Box>
    );
};

PaymentSubmittionForm.propTypes = {
    readOnly: PropTypes.bool.isRequired,
    data: PropTypes.object
};

export default PaymentSubmittionForm;
